import React, { useState } from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { Box, Button, Typography } from "components/ui";
import { useIsMobile } from "utils/hooks/useIsMobile";
import { SpendDashboard } from "store/abcoApi";

interface Props {
	spendData: SpendDashboard | undefined;
}

export default function FinancialChart({ spendData }: Props) {
	const data = spendData?.currentYear;
	const [showSpend, setShowSpend] = useState(true);
	const [showBudget, setShowBudget] = useState(false);
	const [showOrders, setShowOrders] = useState(false);
	const isMobile = useIsMobile();

	const chartStyle = {
		fontFamily: "Roboto_400Regular",
	};

	if (isMobile) {
		return (
			<ResponsiveContainer width="100%" height={400}>
				<LineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
					<CartesianGrid strokeDasharray="3 3" />
					<XAxis dataKey="month" style={chartStyle} />
					<YAxis yAxisId="left" style={chartStyle} />
					<YAxis yAxisId="right" orientation="right" style={chartStyle} />
					<Tooltip contentStyle={chartStyle} />
					<Legend wrapperStyle={chartStyle} />
					{showSpend && <Line yAxisId="left" type="monotone" dataKey="spend" stroke="#ff7676" activeDot={{ r: 8 }} />}
					{showBudget && <Line yAxisId="left" type="stepAfter" dataKey="budget" stroke="#4a5568" strokeWidth={2} />}
					{showOrders && <Line yAxisId="right" type="monotone" dataKey="orders" stroke="#9ca3af" strokeDasharray="5 5" />}
				</LineChart>
			</ResponsiveContainer>
		);
	}
	return (
		<Box>
			<ResponsiveContainer width="100%" height={400}>
				<LineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
					<CartesianGrid strokeDasharray="3 3" />
					<XAxis dataKey="month" style={chartStyle} />
					<YAxis yAxisId="left" style={chartStyle} />
					<YAxis yAxisId="right" orientation="right" style={chartStyle} />
					<Tooltip contentStyle={chartStyle} />
					<Legend wrapperStyle={chartStyle} />
					{showSpend && <Line yAxisId="left" type="monotone" dataKey="spend" stroke="#ff7676" activeDot={{ r: 8 }} />}
					{showBudget && <Line yAxisId="left" type="stepAfter" dataKey="budget" stroke="#4a5568" strokeWidth={2} />}
					{showOrders && <Line yAxisId="right" type="monotone" dataKey="orders" stroke="#9ca3af" strokeDasharray="5 5" />}
				</LineChart>
			</ResponsiveContainer>
			{/* <Box>
				<Button
				// onClick={() => setShowSpend(!showSpend)}
				//   variant={showSpend ? "default" : "outline"}
				>
					Spend
				</Button>
				<Button
				// onClick={() => setShowBudget(!showBudget)}
				//   variant={showBudget ? "default" : "outline"}
				>
					Budget
				</Button>
				<Button
				// onClick={() => setShowOrders(!showOrders)}
				//   variant={showOrders ? "default" : "outline"}
				>
					# Orders
				</Button>
			</Box> */}
		</Box>
	);
}
